export function getUtmFromRoute(route) {
  if (!route) return '';

  const queryPart = route.query.c || '';
  let hashPart = route.hash || '';
  if (hashPart && hashPart.includes('&')) hashPart = hashPart.split('&')[0];

  const combined = `${queryPart}${hashPart}`;
  const decoded = decodeURIComponent(combined);

  return decoded;
}
